<template>
  <span>{{ bdtFormat() }}</span>
</template>
<script>
  export default {
    props: ["amount"],
    methods: {
      bdtFormat() {
        let formatter = new Intl.NumberFormat("en-IN");
        return formatter.format(this.amount.toFixed(2));
      },
    },
  };
</script>
